module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 63
// module chunks = 0